/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorCodesModel,
  FavoriteStatusModel,
  GetNotifications200Response,
  NormalAuthRequestModel,
  NormalAuthResponseModel,
  NotificationModel,
  SeriesSummaryModel,
  UserMissionItemModel,
  ViewedPopupRequestModel,
} from '../models/index';
import {
    ErrorCodesModelFromJSON,
    ErrorCodesModelToJSON,
    FavoriteStatusModelFromJSON,
    FavoriteStatusModelToJSON,
    GetNotifications200ResponseFromJSON,
    GetNotifications200ResponseToJSON,
    NormalAuthRequestModelFromJSON,
    NormalAuthRequestModelToJSON,
    NormalAuthResponseModelFromJSON,
    NormalAuthResponseModelToJSON,
    NotificationModelFromJSON,
    NotificationModelToJSON,
    SeriesSummaryModelFromJSON,
    SeriesSummaryModelToJSON,
    UserMissionItemModelFromJSON,
    UserMissionItemModelToJSON,
    ViewedPopupRequestModelFromJSON,
    ViewedPopupRequestModelToJSON,
} from '../models/index';

export interface AddSeriesToFavoriteRequest {
    seriesHash: string;
    xComiciUserTokenRequired: string;
}

export interface DeleteSeriesFromFavoriteRequest {
    seriesHash: string;
    xComiciUserTokenRequired: string;
}

export interface GachaShareRequest {
    xComiciUserTokenRequired: string;
}

export interface GetFavoriteSeriesRequest {
    page?: number;
    size?: number;
    xComiciUserToken?: string;
}

export interface GetNotificationByIdRequest {
    id: string;
    xComiciUserToken?: string;
}

export interface GetNotificationsRequest {
    page?: number;
    size?: number;
    xComiciUserToken?: string;
    isRead?: boolean;
}

export interface GetSeriesFavoriteStatusRequest {
    seriesHash: string;
    xComiciUserToken?: string;
}

export interface LikeEpisodeRequest {
    articleHash: string;
    type?: number;
    xComiciUserToken?: string;
}

export interface PostNormalAuthRequest {
    userAgent: string;
    normalAuthRequestModel: NormalAuthRequestModel;
}

export interface ShareSeriesRequest {
    seriesHash: string;
    xComiciUserTokenRequired: string;
}

export interface StoreEpisodeViewHistoryRequest {
    articleHash: string;
    xComiciUserToken?: string;
}

export interface StoreReadCompleteEpisodeHistoryRequest {
    articleHash: string;
    xComiciUserTokenRequired: string;
}

export interface StoreViewedPopupRequest {
    viewedPopupRequestModel: ViewedPopupRequestModel;
    xComiciUserToken?: string;
}

export interface UpdateAllNotificationsReadStatusByUserRequest {
    xComiciUserToken?: string;
}

export interface UpdateNotificationsReadStatusByUserRequest {
    id: string;
    xComiciUserToken?: string;
}

/**
 * 
 */
export class UserActionApi extends runtime.BaseAPI {

    /**
     * 作品をお気に入りに追加します。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理も行い、必要であれば報酬を付与します。 ミッションを達成した場合は、戻り値に対象のミッション情報をセットして返却します。
     * お気に入り追加
     */
    async addSeriesToFavoriteRaw(requestParameters: AddSeriesToFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMissionItemModel>>> {
        if (requestParameters.seriesHash === null || requestParameters.seriesHash === undefined) {
            throw new runtime.RequiredError('seriesHash','Required parameter requestParameters.seriesHash was null or undefined when calling addSeriesToFavorite.');
        }

        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling addSeriesToFavorite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/{series_hash}/favorite`.replace(`{${"series_hash"}}`, encodeURIComponent(String(requestParameters.seriesHash))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMissionItemModelFromJSON));
    }

    /**
     * 作品をお気に入りに追加します。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理も行い、必要であれば報酬を付与します。 ミッションを達成した場合は、戻り値に対象のミッション情報をセットして返却します。
     * お気に入り追加
     */
    async addSeriesToFavorite(requestParameters: AddSeriesToFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMissionItemModel>> {
        const response = await this.addSeriesToFavoriteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 作品をお気に入りから削除します。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理(達成数のカウントダウン)も行います。
     * お気に入り削除
     */
    async deleteSeriesFromFavoriteRaw(requestParameters: DeleteSeriesFromFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.seriesHash === null || requestParameters.seriesHash === undefined) {
            throw new runtime.RequiredError('seriesHash','Required parameter requestParameters.seriesHash was null or undefined when calling deleteSeriesFromFavorite.');
        }

        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling deleteSeriesFromFavorite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/{series_hash}/favorite`.replace(`{${"series_hash"}}`, encodeURIComponent(String(requestParameters.seriesHash))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 作品をお気に入りから削除します。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理(達成数のカウントダウン)も行います。
     * お気に入り削除
     */
    async deleteSeriesFromFavorite(requestParameters: DeleteSeriesFromFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSeriesFromFavoriteRaw(requestParameters, initOverrides);
    }

    /**
     * ガチャ再挑戦のために必要となるX(ツイッター)でのシェア行為を記録します。 ガチャ実行履歴のレコードにシェア済フラグを設定します。
     * ガチャ再挑戦のためにシェアする
     */
    async gachaShareRaw(requestParameters: GachaShareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling gachaShare.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/achievement/gacha/share`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ガチャ再挑戦のために必要となるX(ツイッター)でのシェア行為を記録します。 ガチャ実行履歴のレコードにシェア済フラグを設定します。
     * ガチャ再挑戦のためにシェアする
     */
    async gachaShare(requestParameters: GachaShareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.gachaShareRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザーがお気に入りに追加した作品を返します。  ユーザーのトークンを X-Comici-Access-Token として渡します。
     * お気に入り作品リスト取得
     */
    async getFavoriteSeriesRaw(requestParameters: GetFavoriteSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SeriesSummaryModel>>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/favorites`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SeriesSummaryModelFromJSON));
    }

    /**
     * ユーザーがお気に入りに追加した作品を返します。  ユーザーのトークンを X-Comici-Access-Token として渡します。
     * お気に入り作品リスト取得
     */
    async getFavoriteSeries(requestParameters: GetFavoriteSeriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SeriesSummaryModel>> {
        const response = await this.getFavoriteSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 通知のIDにより、ユーザーの通知詳細を戻します
     * 通知1件取得
     */
    async getNotificationByIdRaw(requestParameters: GetNotificationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getNotificationById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationModelFromJSON(jsonValue));
    }

    /**
     * 通知のIDにより、ユーザーの通知詳細を戻します
     * 通知1件取得
     */
    async getNotificationById(requestParameters: GetNotificationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationModel> {
        const response = await this.getNotificationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信されている通知一覧を取得します。  取得される情報は通知のみを含みます。
     * 通知リスト取得
     */
    async getNotificationsRaw(requestParameters: GetNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNotifications200Response>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.isRead !== undefined) {
            queryParameters['isRead'] = requestParameters.isRead;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNotifications200ResponseFromJSON(jsonValue));
    }

    /**
     * 配信されている通知一覧を取得します。  取得される情報は通知のみを含みます。
     * 通知リスト取得
     */
    async getNotifications(requestParameters: GetNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNotifications200Response> {
        const response = await this.getNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * # ユーザーお気に入りの作品  ユーザーは気に入った作品を「お気に入り」に追加することができます。  ユーザーが特定の作品をお気に入りに追加しているかどうかの状態を取得します。
     * お気に入り状態取得
     */
    async getSeriesFavoriteStatusRaw(requestParameters: GetSeriesFavoriteStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteStatusModel>> {
        if (requestParameters.seriesHash === null || requestParameters.seriesHash === undefined) {
            throw new runtime.RequiredError('seriesHash','Required parameter requestParameters.seriesHash was null or undefined when calling getSeriesFavoriteStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/{series_hash}/favorite`.replace(`{${"series_hash"}}`, encodeURIComponent(String(requestParameters.seriesHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FavoriteStatusModelFromJSON(jsonValue));
    }

    /**
     * # ユーザーお気に入りの作品  ユーザーは気に入った作品を「お気に入り」に追加することができます。  ユーザーが特定の作品をお気に入りに追加しているかどうかの状態を取得します。
     * お気に入り状態取得
     */
    async getSeriesFavoriteStatus(requestParameters: GetSeriesFavoriteStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteStatusModel> {
        const response = await this.getSeriesFavoriteStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * エピソードにいいねを贈ります。
     * いいねする
     */
    async likeEpisodeRaw(requestParameters: LikeEpisodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.articleHash === null || requestParameters.articleHash === undefined) {
            throw new runtime.RequiredError('articleHash','Required parameter requestParameters.articleHash was null or undefined when calling likeEpisode.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/articles/{article_hash}/like`.replace(`{${"article_hash"}}`, encodeURIComponent(String(requestParameters.articleHash))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * エピソードにいいねを贈ります。
     * いいねする
     */
    async likeEpisode(requestParameters: LikeEpisodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.likeEpisodeRaw(requestParameters, initOverrides);
    }

    /**
     * username or email + password での認証を行い、トークンを返却します username は大文字/小文字の区別を行いません。 認証成功時は以下の処理が行われます   * GA4のuser_pseudo_id (デバイス固有のID) とUAの保存   * サイト単位のログイン履歴保存   * 規約同意チェック   * 復帰ユーザーミッション達成判定 (ミッション達成時のみミッション情報をレスポンスで返却) 認証失敗時は失敗回数がカウントされ、上限を超えるとアカウントがロックされます
     * ログイン認証 (username, email)
     */
    async postNormalAuthRaw(requestParameters: PostNormalAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NormalAuthResponseModel>> {
        if (requestParameters.userAgent === null || requestParameters.userAgent === undefined) {
            throw new runtime.RequiredError('userAgent','Required parameter requestParameters.userAgent was null or undefined when calling postNormalAuth.');
        }

        if (requestParameters.normalAuthRequestModel === null || requestParameters.normalAuthRequestModel === undefined) {
            throw new runtime.RequiredError('normalAuthRequestModel','Required parameter requestParameters.normalAuthRequestModel was null or undefined when calling postNormalAuth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.userAgent !== undefined && requestParameters.userAgent !== null) {
            headerParameters['User-Agent'] = String(requestParameters.userAgent);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/login/auth/normal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NormalAuthRequestModelToJSON(requestParameters.normalAuthRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NormalAuthResponseModelFromJSON(jsonValue));
    }

    /**
     * username or email + password での認証を行い、トークンを返却します username は大文字/小文字の区別を行いません。 認証成功時は以下の処理が行われます   * GA4のuser_pseudo_id (デバイス固有のID) とUAの保存   * サイト単位のログイン履歴保存   * 規約同意チェック   * 復帰ユーザーミッション達成判定 (ミッション達成時のみミッション情報をレスポンスで返却) 認証失敗時は失敗回数がカウントされ、上限を超えるとアカウントがロックされます
     * ログイン認証 (username, email)
     */
    async postNormalAuth(requestParameters: PostNormalAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NormalAuthResponseModel> {
        const response = await this.postNormalAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 作品をシェアします。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理も行い、必要であれば報酬を付与します。 ミッションを達成した場合は、戻り値に対象のミッション情報をセットして返却します。
     * 作品をシェアする
     */
    async shareSeriesRaw(requestParameters: ShareSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMissionItemModel>>> {
        if (requestParameters.seriesHash === null || requestParameters.seriesHash === undefined) {
            throw new runtime.RequiredError('seriesHash','Required parameter requestParameters.seriesHash was null or undefined when calling shareSeries.');
        }

        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling shareSeries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/{series_hash}/share`.replace(`{${"series_hash"}}`, encodeURIComponent(String(requestParameters.seriesHash))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMissionItemModelFromJSON));
    }

    /**
     * 作品をシェアします。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理も行い、必要であれば報酬を付与します。 ミッションを達成した場合は、戻り値に対象のミッション情報をセットして返却します。
     * 作品をシェアする
     */
    async shareSeries(requestParameters: ShareSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMissionItemModel>> {
        const response = await this.shareSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザーの閲覧したエピソード履歴を保存する
     * エピソード閲覧
     */
    async storeEpisodeViewHistoryRaw(requestParameters: StoreEpisodeViewHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.articleHash === null || requestParameters.articleHash === undefined) {
            throw new runtime.RequiredError('articleHash','Required parameter requestParameters.articleHash was null or undefined when calling storeEpisodeViewHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/articles/{article_hash}/view`.replace(`{${"article_hash"}}`, encodeURIComponent(String(requestParameters.articleHash))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ユーザーの閲覧したエピソード履歴を保存する
     * エピソード閲覧
     */
    async storeEpisodeViewHistory(requestParameters: StoreEpisodeViewHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeEpisodeViewHistoryRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザーの読了話情報の履歴を保存します。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理も行い、必要であれば報酬を付与します。 ミッションを達成した場合は、戻り値に対象のミッション情報をセットして返却します。
     * エピソード読了
     */
    async storeReadCompleteEpisodeHistoryRaw(requestParameters: StoreReadCompleteEpisodeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMissionItemModel>>> {
        if (requestParameters.articleHash === null || requestParameters.articleHash === undefined) {
            throw new runtime.RequiredError('articleHash','Required parameter requestParameters.articleHash was null or undefined when calling storeReadCompleteEpisodeHistory.');
        }

        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling storeReadCompleteEpisodeHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/articles/{article_hash}/read`.replace(`{${"article_hash"}}`, encodeURIComponent(String(requestParameters.articleHash))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMissionItemModelFromJSON));
    }

    /**
     * ユーザーの読了話情報の履歴を保存します。 ミッションの取り扱いがあるサイトにおいてはミッションの進捗管理も行い、必要であれば報酬を付与します。 ミッションを達成した場合は、戻り値に対象のミッション情報をセットして返却します。
     * エピソード読了
     */
    async storeReadCompleteEpisodeHistory(requestParameters: StoreReadCompleteEpisodeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMissionItemModel>> {
        const response = await this.storeReadCompleteEpisodeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 閲覧したポップアップをデータベースに保存する 保存したポップアップは表示しないようにする
     * ポップアップ閲覧
     */
    async storeViewedPopupRaw(requestParameters: StoreViewedPopupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.viewedPopupRequestModel === null || requestParameters.viewedPopupRequestModel === undefined) {
            throw new runtime.RequiredError('viewedPopupRequestModel','Required parameter requestParameters.viewedPopupRequestModel was null or undefined when calling storeViewedPopup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/popups/view`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ViewedPopupRequestModelToJSON(requestParameters.viewedPopupRequestModel),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 閲覧したポップアップをデータベースに保存する 保存したポップアップは表示しないようにする
     * ポップアップ閲覧
     */
    async storeViewedPopup(requestParameters: StoreViewedPopupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.storeViewedPopupRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザーにより通知を全て既読する
     * 通知リスト全件既読
     */
    async updateAllNotificationsReadStatusByUserRaw(requestParameters: UpdateAllNotificationsReadStatusByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/notifications`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ユーザーにより通知を全て既読する
     * 通知リスト全件既読
     */
    async updateAllNotificationsReadStatusByUser(requestParameters: UpdateAllNotificationsReadStatusByUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAllNotificationsReadStatusByUserRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザーにより通知を既読する
     * 通知1件既読
     */
    async updateNotificationsReadStatusByUserRaw(requestParameters: UpdateNotificationsReadStatusByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateNotificationsReadStatusByUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ユーザーにより通知を既読する
     * 通知1件既読
     */
    async updateNotificationsReadStatusByUser(requestParameters: UpdateNotificationsReadStatusByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNotificationsReadStatusByUserRaw(requestParameters, initOverrides);
    }

}
